import './Icon.css';
import { IconProps } from './iconType';

export const CrossIcon: React.FC<IconProps> = ({
  size = 12,
  color,
  className,
}) => {
  return (
    <span
      className={['icon', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size, color }}
    >
      <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M14.292 4.99999C14.4873 4.80477 14.8038 4.80479 14.9991 4.99999C15.1943 5.19525 15.1943 5.51177 14.9991 5.70702L10.7061 9.99901L14.9991 14.291C15.1942 14.4863 15.1942 14.8028 14.9991 14.998C14.8039 15.1931 14.4873 15.1931 14.292 14.998L9.99908 10.7051L5.70709 14.998C5.51185 15.1931 5.19528 15.1931 5.00005 14.998C4.80491 14.8028 4.80495 14.4862 5.00005 14.291L9.29205 9.99901L5.00005 5.70702C4.80484 5.51177 4.80482 5.19525 5.00005 4.99999C5.19529 4.80477 5.51182 4.80479 5.70709 4.99999L9.99908 9.29198L14.292 4.99999Z'
          fill='#8B8B8B'
        />
      </svg>
    </span>
  );
};
